export enum ConnectedAccountType {
  Contacts = 1,
  Calendar = 2,
  Files = 3,
}